import { devEnvMap, globalEnvMap } from '~/config';

export const getGlobalArg = (key: keyof AppConfig): AppConfig[keyof AppConfig] => {
    if (import.meta.env.DEV) {
        return devEnvMap[key];
    }

    return globalEnvMap[key];
};
